import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import './FarecardRemove.css';
import { Farecard } from '../../services/types/apitypes';

type FarecardRemoveProps = {
  goBack: () => void;
  remove: (f: Farecard) => void;
  card: Farecard;
};

export default function FarecardRemove({
  goBack,
  card,
  remove,
}: FarecardRemoveProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <div className="ion-text-center">
        <IonIcon
          className="farcards-remove-circle"
          src="assets/icon/card-remove-circle.svg"
        ></IonIcon>
      </div>

      <h1 className="h1 pt-2 ion-text-center">{t('farecards.remove')}</h1>
      <p className="pt-1 instructions ion-text-center">
        {t('farecards.removeinstruction')}
      </p>
      <p className="pt-1 instructions ion-text-center">
          {t('farecards.removeinstruction2')}
      </p>

      <div className="pt-5 ion-text-center">
        <IonButton
          className="btn-default "
          expand="block"
          onClick={() => remove(card)}
        >
          {t('farecards.remove')}
        </IonButton>
      </div>
      <div className="ion-text-center">
        <IonButton
          onClick={goBack}
          fill="outline"
          expand="block"
          className="btn-default"
        >
          {t('home.cancel')}
        </IonButton>
      </div>
    </>
  );
}
